import { render } from "./BarGraphPlaceholder.vue?vue&type=template&id=20a8e894&scoped=true"
import script from "./BarGraphPlaceholder.vue?vue&type=script&lang=js"
export * from "./BarGraphPlaceholder.vue?vue&type=script&lang=js"

import "./BarGraphPlaceholder.vue?vue&type=style&index=0&id=20a8e894&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20a8e894"]])

export default __exports__